// A Swedish registration number is conventionally written with a space ("CCS 233"), and people
// type a hyphen just as readily. The vehicle registry only answers for the bare characters, and
// the stored car row is keyed the same way, so a plate typed the normal way found nothing: the
// seller got "vehicle not found" and the buyer "this car is not available in Klargo yet".
// Every lookup and every write goes through this first.
export const normalizeRegistration = (value) =>
  String(value ?? "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toUpperCase();
